import { queryParkInfo } from '../../services/incubator';
import { Feedback} from '@alife/next';
const Toast = Feedback.toast;
export default {
  namespace: 'incubatordetailServer',
  state: {
    parkId:0,
    parkBaseInfoVO:{
      addressDetail:'',
      administratorAliyunId:'',
      city:'',
      deskCount:0,
      location:'',
      parkAcreage:0,
      parkName:'',
      parkbrief:'',
      policy:'',
      province:'',
      siteEquipment:'',
      status:0
    },
    parkExtInfoVO:{
      addressPicUrl:'',
      description:''
    },
    parkMediaExtInfoVOList:[
    ]

  },
  subscriptions: {
    // setup({ dispatch, history }) {}
  },
  
  effects: {
    //请求园区列表
    * queryParkInfo({ parkId }, { call, put }) {
      let detailData = yield call(queryParkInfo,parkId);
      if(detailData.success){
        yield put({ 
          type: 'detail',
          payload:{
            parkBaseInfoVO:detailData.data.parkBaseInfoVO ? detailData.data.parkBaseInfoVO : {},
            parkExtInfoVO:detailData.data.parkExtInfoVO ? detailData.data.parkExtInfoVO : {},
            parkMediaExtInfoVOList:detailData.data.parkMediaExtInfoVOList ? detailData.data.parkMediaExtInfoVOList:[]
          } 
        });
      }else{
        Toast.error('查询详情失败');
      }
    }
  },
  
  reducers: {
    // 当前数据
    detail(state, { payload }) {
      return {
        ...state,...payload
      };
    },
    // 列表数据
    listData(state, { payload }) {
      return {...state,...payload};
    }
  }
    
};
  


// WEBPACK FOOTER //
// ./src/scripts/models/IncubatorDetailServer/IncubatorDetailServer.js